  var CART_DRAWER_SECTION = "hd--global--cart-drawer";

  // Render the drawer from the /cart/add.js response (requested via `sections`),
  // falling back to a section fetch if the payload is missing.
  function renderCartDrawerFromResponse(cartDrawer, response) {
    if (!cartDrawer) return Promise.resolve();
    const html = response && response.sections && response.sections[CART_DRAWER_SECTION];
    const render = (markup) => {
      cartDrawer.renderContents(markup);
      document.querySelectorAll(".component--cart-drawer--line-item").forEach((item) => {
        if (item.innerHTML.includes("45514264903897")) item.classList.add("free-gift-item");
      });
    };
    if (html) {
      render(html);
      return Promise.resolve();
    }
    return fetch(`/?section_id=${CART_DRAWER_SECTION}`)
      .then((r) => r.text())
      .then(render);
  }

  function addToCartWithDrawer(payload) {
    const body = JSON.stringify({
      ...payload,
      sections: CART_DRAWER_SECTION,
      sections_url: window.location.pathname,
    });
    return fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body }).then((response) =>
      response.json().then((data) => {
        if (!response.ok || data.status) {
          const error = new Error(data.description || data.message || "");
          error.isCartError = true;
          throw error;
        }
        return data;
      })
    );
  }

  class ProductMediaSlider extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      let uspsSlider = document.querySelector('.page--product_usps_points_slider');
  if (uspsSlider) {
      let splide_usps = new Splide(uspsSlider, {
          perPage: 1,
          pagination: false,
          arrows: true,
          drag: false,
      }).mount();
  }
      let splide = new Splide(".component--product--media__slider", {
        pagination: true,
        perPage    : 1,
        gap:'8px',
        arrows: false,
        focus: 'center',
        mediaQuery: 'min',
        breakpoints: {
          768: {
            perPage: 1, 
          }
        }
      });
      splide.on("mounted move", function () {
        console.log('slide');
        setTimeout(function(){
        const slides = document.querySelectorAll('.mobile-media .splide__slide');

        slides.forEach(slide => {
            if (!slide.classList.contains('is-active') && !slide.classList.contains('is-visible')) {
                const video = slide.querySelector('video');
                
                if (video) {
                    video.pause();
                }
            }
        });
  const activeSlide = document.querySelector('.mobile-media .splide__slide.is-active.is-visible');

  if (activeSlide) {
      const video = activeSlide.querySelector('video');
    const videoSource = activeSlide.querySelector('video source');

      if (video && videoSource) {
          const currentSrc = videoSource.src;
          videoSource.src = currentSrc; // Reassigning the same src
          video.load(); // Load the video again

          video.play().catch(error => {
              console.error('Error playing the video:', error);
          });
      }
  }
          },500);
      });
      splide.mount();
    }
  }
  customElements.define("product-media-slider", ProductMediaSlider);
  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
      this.bar = this.querySelector(".component--product--sticky-bar");
      this.footer = document.querySelector(".global--footer");
      this.productForm = document.querySelector("product-form");
      this.cart = document.querySelector("cart-drawer");
      this.bindEvents();
      this.toggle.bind(this);
    }
    bindEvents() {
      if (!this.productForm || !this.productForm.form) return;
      document.addEventListener("scroll", this.toggle.bind(this));
      const stickyButton = document.querySelector(".component--product--sticky-bar__button");
      if (stickyButton) stickyButton.addEventListener("click", this.onSubmitHandler.bind(this));
    }
    onSubmitHandler() {
      const submitButton = this.productForm.querySelector('[type="submit"]');
      if (submitButton) submitButton.setAttribute("disabled", true);
      this.productForm.hideError();

      addToCartWithDrawer(JSON.parse(serializeForm(this.productForm.form)))
        .then((response) => renderCartDrawerFromResponse(this.cart, response))
        .catch((e) => {
          console.error(e);
          this.productForm.showError(e.isCartError ? e.message : null);
        })
        .finally(() => {
          if (submitButton) submitButton.removeAttribute("disabled");
        });
    }
    inViewport(el) {
      const rect = el.getBoundingClientRect();
      const vWidth = window.innerWidth || document.documentElement.clientWidth;
      const vHeight = window.innerHeight || document.documentElement.clientHeight;
      const efp = function (x, y) {
        return document.elementFromPoint(x, y);
      };
      // Return false if it's not in the viewport
      if (
        rect.right < 0 ||
        rect.bottom < 0 ||
        rect.left > vWidth ||
        rect.top > vHeight
      ) {
        return false;
      }
      // Return true if any of its four corners are visible
      return (
        el.contains(efp(rect.left, rect.top)) ||
        el.contains(efp(rect.right, rect.top)) ||
        el.contains(efp(rect.right, rect.bottom)) ||
        el.contains(efp(rect.left, rect.bottom))
      );
    }
    toggle() {
      const visible = this.inViewport(this.productForm.form);
      const wrapper = document.querySelector(".component--product--wrapper");
      if (visible || (wrapper && this.inViewport(wrapper))) {
        this.classList.remove("component--product--sticky-bar--active");
        if (this.footer) this.footer.removeAttribute("style");
      } else {
        this.classList.add("component--product--sticky-bar--active");
        if (this.footer) this.footer.style.marginBottom = this.offsetHeight + "px";
      }
    }
  }
  customElements.define("product-sticky-bar", ProductStickyBar);
  class ProductFAQ extends HTMLElement {
    constructor() {
      super();
      this.accordions = document.querySelectorAll(
        ".component--product--faq--question"
      );
      this.bindEvents();
    }
    bindEvents() {
      this.accordions.forEach((accordion) =>
        accordion.addEventListener("click", this.toggleAccordion.bind(this))
      );
    }
    toggleAccordion(event) {
      const element = event.currentTarget;
      element.classList.toggle("component--product--faq--question--active");
      this.accordions.forEach((accordion) => {
        if (accordion !== element) {
          accordion.classList.remove("component--product--faq--question--active");
        }
      });
    }
  }
  customElements.define("product-faq", ProductFAQ);
  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".component--product--ugc--slider")) {
      const splide = new Splide(".component--product--ugc--slider", {
        type: "loop",
        perPage: 4,
        perMove: 1,
        pagination: false,
        arrows: false,
        gap: "24px",
        breakpoints: {
          600: {
            perPage: 1,
            gap: "16px",
            padding: "100px",
            pagination: true,
          },
        },
      }).mount();
      const videoWrappers = document.querySelectorAll(
        ".page--product--media__video-wrapper"
      );
      if (videoWrappers.length > 0) {
        videoWrappers.forEach((video, index) => {
          video.addEventListener("click", (e) => {
            videoWrappers.forEach((video, i) => {
              if (index != i) {
                video.querySelector("video").muted = true;
                video.querySelector(
                  ".page--product--media__play-btn"
                ).style.display = "block";
                video.querySelector("video").pause();
                video.querySelector("video").currentTime = 0;
              } else {
                if (video.querySelector("video").muted != true) {
                  video.querySelector(
                    ".page--product--media__play-btn"
                  ).style.display = "block";
                  video.querySelector("video").pause();
                  video.querySelector("video").currentTime = 0;
                  video.querySelector("video").muted = true;
                } else {
                  video.querySelector("video").currentTime = 0;
                  video.querySelector("video").play();
                  video.querySelector(
                    ".page--product--media__play-btn"
                  ).style.display = "none";
                  video.querySelector("video").muted = false;
                }
              }
            });
          });
        });
      }
    }
    if (document.querySelector(".page--product--about__media-wrapper")) {
      const videoWrapper = document.querySelector(
        ".page--product--about__media-wrapper"
      );
      const button = document.querySelector(".page--product--about__play");
      const buttonWrapper = document.querySelector(
        ".page--product--about__play-btn"
      );
      buttonWrapper.addEventListener("click", (e) => {
        videoWrapper.querySelector("video").currentTime = 0;
        videoWrapper.querySelector("video").play();
        buttonWrapper.style.display = "none";
        videoWrapper.querySelector("video").muted = false;
      });
      videoWrapper.querySelector("video").addEventListener("click", (e) => {
        buttonWrapper.style.display = "block";
        videoWrapper.querySelector("video").muted = true;
      });
    }
  });
  class RefillSubscriptionSelector extends HTMLElement {
    constructor() {
      super();
      this.onetime = document.querySelector("#product-recharge-selector__once");
      this.subscription = document.querySelector(
        "#product-recharge-selector__recurring"
      );
      this.isSubscription = false;
      //this.addEventListener("change", this.onChange);
      /*document
        .querySelector(".product-recharge-selector__select")
        .addEventListener("change", this.selectSubscription);*/
      this.bindEvents();
    }
    bindEvents() {
      document.addEventListener("DOMContentLoaded", () => {
        if (this.onetime) this.onetime.addEventListener("click", this.selectOneTime.bind(this));
        if (this.subscription)
          this.subscription.addEventListener("click", this.selectSubscription.bind(this));
        const options = document.querySelector(".product-recharge-selector__options");
        if (options) options.addEventListener("change", this.selectSubscription.bind(this));
      });
    }
    onChange() {
      this.updateForm();
      if (this.option.value == "true") {
        this.selectSubscription();
      } else {
        this.selectOneTime();
      }
    }
    updateButton(price) {
      const addButtons = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      addButtons.forEach((addButton) => {
        const qty = addButton.querySelector('[name="quantity"]').value;
        addButton = addButton?.querySelector('[name="add"]');
        if (!addButton) return;
        const total = JSON.parse(price) * JSON.parse(qty);
        addButton.setAttribute("data-product-price", price);
        addButton.textContent =
          window.variantStrings.addToCart + " — $" + formatMoney(total);
      });
    }
    selectOneTime() {
      this.isSubscription = false;
      this.querySelector(".product-recharge-selector__mode--once").classList.add(
        "product-recharge-selector__mode--active"
      );
      this.querySelector(
        ".product-recharge-selector__mode--recurring"
      ).classList.remove("product-recharge-selector__mode--active");
      this.querySelector(
        ".product-recharge-selector__option-wrapper"
      ).classList.remove("product-recharge-selector__option-wrapper--active");
      this.querySelector(
        ".product-recharge-selector__mode--recurring"
      ).style.borderTop = "none";
      this.querySelector(
        ".product-recharge-selector__mode--once"
      ).style.borderBottomWidth = "1px";
      this.querySelector(
        ".product-recharge-selector__mode--once"
      ).style.borderBottomStyle = "solid";
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const ele = productForm.querySelector('input[name="selling_plan"]');
        ele.remove();
      });
      const price = this.querySelector(
        ".product-recharge-selector__mode--once"
      ).getAttribute("data-price");
      const addButtons = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      addButtons.forEach((addButton) => {
        addButton = addButton?.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.textContent = window.variantStrings.addToCart + " — $" + price;
      });
      if (document.querySelector(".component--product--sticky-bar__button")) {
        document.querySelector(
          ".component--product--sticky-bar__button"
        ).textContent = window.variantStrings.addToCart + " — $" + price;
      }
    }
    selectSubscription() {
      this.isSubscription = true;
      document
        .querySelector(".product-recharge-selector__mode--once")
        .classList.remove("product-recharge-selector__mode--active");
      document
        .querySelector(".product-recharge-selector__mode--recurring")
        .classList.add("product-recharge-selector__mode--active");
      this.querySelector(
        ".product-recharge-selector__option-wrapper"
      ).classList.add("product-recharge-selector__option-wrapper--active");
      this.querySelector(
        ".product-recharge-selector__mode--once"
      ).style.borderBottom = "none";
      this.querySelector(
        ".product-recharge-selector__mode--recurring"
      ).style.borderTopWidth = "1px";
      this.querySelector(
        ".product-recharge-selector__mode--recurring"
      ).style.borderTopStyle = "solid";
      this.updateOptions();
      // create input
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        if (productForm.querySelector('input[name="selling_plan"]')) {
          productForm
            .querySelector('input[name="selling_plan"]')
            .setAttribute("value", this.plan.value);
        } else {
          let input = document.createElement("input");
          input.type = "hidden";
          input.setAttribute("name", "selling_plan");
          input.setAttribute("value", this.plan.value);
          productForm.appendChild(input);
        }
      });
      const price = document
        .querySelector(".product-recharge-selector__mode--recurring")
        .getAttribute("data-price");
      const addButtons = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      addButtons.forEach((addButton) => {
        addButton = addButton?.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.textContent = window.variantStrings.addToCart + " — $" + price;
      });
      if (document.querySelector(".component--product--sticky-bar__button")) {
        document.querySelector(
          ".component--product--sticky-bar__button"
        ).textContent = window.variantStrings.addToCart + " — $" + price;
      }
    }
    updateSubscription() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        productForm
          .querySelector('input[name="selling_plan"]')
          .setAttribute("value", this.plan.value);
      });
    }
    updateOptions() {
      this.plan = Array.from(
        this.querySelectorAll(".product-recharge-selector__frequency-input")
      ).find((radio) => radio.checked);
      Array.from(
        this.querySelectorAll(".product-recharge-selector__frequency-input")
      ).find((radio) => {
        if (this.plan.value == radio.value) {
          radio.checked = true;
          radio.setAttribute("checked", "");
        } else {
          radio.checked = false;
          radio.removeAttribute("checked");
        }
      });
    }
    updateForm() {
      this.option = Array.from(
        this.querySelectorAll(".product-recharge-selector__mode-input")
      ).find((radio) => radio.checked);
      Array.from(
        this.querySelectorAll(".product-recharge-selector__mode-input")
      ).find((radio) => {
        if (this.option.value == radio.value) {
          radio.checked = true;
          radio.setAttribute("checked", "");
        } else {
          radio.checked = false;
          radio.removeAttribute("checked");
        }
      });
    }
  }
  customElements.define(
    "refill-subscription-selector",
    RefillSubscriptionSelector
  );
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart = document.querySelector("cart-drawer");
    }
    attachProducts() {
    this.items = [];

    this.upsell = document.querySelector("product-upsell");

    if (document.querySelector("product-upsell")) {
      this.upsell.lineItems.forEach((item) => {
        this.items.push({
          id: item.id,
          quantity: 1,
        });
      });
    }

    if (document.querySelector("#addon-product") != null) {
      if (document.querySelector("#addon-product").checked == true) {
        let addonId = document.querySelector("#addon-product").value;

        this.items.push({
          id: addonId,
          quantity: 1,
        });
      }
    }

    const formData = JSON.parse(serializeForm(this.form));

    let item = null;

    if (formData.selling_plan == undefined) {
      item = {
        id: formData.id,
        quantity: 1,
      };
    } else {
      item = {
        id: formData.id,
        quantity: 1,
        selling_plan: formData.selling_plan,
      };
    }

    this.items.push(item);

    const triggerIds = [
      48559660957913,
      46856086716633,
      47617803780313,
      47617839300825,
      43731293110489,
      44822222504153,
      44822223290585,
      44822223814873
    ];

    const freeGiftId = 45514264903897;

    const hasTriggerInCurrentItems = this.items.some(product =>
      triggerIds.includes(Number(product.id))
    );

    if (
  hasTriggerInCurrentItems &&
  !document.querySelector('.free-gift-item')
) {
  this.items.push({
    id: freeGiftId,
    quantity: 1,
    properties: {
      _free_gift: 'true'
    }
  });
}
  }
    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute("disabled", true);
      this.hideError();

      this.attachProducts();

      addToCartWithDrawer({ items: this.items })
        .then((response) => renderCartDrawerFromResponse(this.cart, response))
        .catch((e) => {
          console.error(e);
          this.showError(e.isCartError ? e.message : null);
        })
        .finally(() => {
          submitButton.removeAttribute("disabled");
        });
    }
    showError(message) {
      let error = this.querySelector(".component--product--form-error");
      if (!error) {
        error = document.createElement("p");
        error.className = "component--product--form-error";
        error.setAttribute("role", "alert");
        this.appendChild(error);
      }
      error.textContent =
        message || (window.cartStrings && window.cartStrings.error) || "Something went wrong. Please try again.";
      error.hidden = false;
      // Reset the "Adding..." button label (global.js listens for this).
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    hideError() {
      const error = this.querySelector(".component--product--form-error");
      if (error) error.hidden = true;
    }
  }
  customElements.define("product-form", ProductForm);
  class ProductDropdown extends HTMLElement {
    constructor() {
      super();
      this.accordion = this.querySelector(
        ".component--product--dropdown__titles"
      );
      this.accordions = document.querySelectorAll(
        ".component--product--dropdown__titles"
      );
      this.bindEvents();
    }
    bindEvents() {
      if (this.accordion) this.accordion.addEventListener("click", this.toggleAccordion.bind(this));
    }
    toggleAccordion(event) {
      const element = event.currentTarget;
      element.classList.toggle("component--product--dropdown__titles--active");
      this.accordions.forEach((accordion) => {
        if (accordion !== element) {
          accordion.classList.remove(
            "component--product--dropdown__titles--active"
          );
        }
      });
    }
  }
  customElements.define("product-dropdown", ProductDropdown);

  class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onVariantChange);

      this.getVariantData.bind(this);
    }
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateURL();
        this.renderProductInfo();
      }
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
    setUnavailable() {
      const addButtons = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
      );
      addButtons.forEach((addButton) => {
        addButton = addButton?.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.textContent = window.variantStrings.unavailable;
        addButton.disabled = true;
      });
      document.querySelector(
        ".component--product--sticky-bar__button"
      ).textContent = window.variantStrings.unavailable;
      document.querySelector(
        ".component--product--sticky-bar__button"
      ).style.pointerEvents = "none";
    }
    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
    renderProductInfo() {
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const mediaSource = html.getElementById("page--product--product__content");
          const mediaD = document.getElementById("page--product--product__content");
          mediaD.innerHTML = mediaSource.innerHTML;
        });
    }
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }
  customElements.define("variant-selector", VariantSelector);

  class ProductUpsell extends HTMLElement {
    constructor() {
      super();

      this.lineItems = [];

      this.upsells = document.querySelectorAll(".component--product--upsell");

      this.onClick.bind(this);

      this.bindEvents();
    }
    bindEvents() {
      this.upsells.forEach((upsell) => {
        upsell
          .querySelector(".component--product--upsell__image-wrapper")
          .addEventListener("click", this.onClick.bind(this));
      });
    }

    onClick(event) {
      const ele = event.currentTarget;
      const id = this.getAttribute("data-add-on-id");

      const isExist = this.lineItems.filter((item) => id == item.id).length > 0;
      if (!isExist) {
        this.attachProduct(event);
        this.updateCheckbox(true, ele);
      } else {
        this.deattachProduct(event);
        this.updateCheckbox(false, ele);
      }
    }

    updateCheckbox(check) {
      if (check) {
        document
          .querySelector(".component--product--upsell__checkbox")
          .classList.add("component--product--upsell__checkbox--active");
      } else {
        document
          .querySelector(".component--product--upsell__checkbox")
          .classList.remove("component--product--upsell__checkbox--active");
      }
    }

    attachProduct() {
      const id = this.getAttribute("data-add-on-id");

      this.lineItems = [
        {
          id: id,
          quantity: 1,
        },
      ];
    }
    deattachProduct() {
      const id = this.getAttribute("data-add-on-id");

      this.lineItems = this.lineItems.filter((item) => id != item.id);
    }
  }

  customElements.define("product-upsell", ProductUpsell);

  // free--gift--js
